import { TYPE_BITEL_REVENUE, TYPE_BITEL_AIRTIME } from "./type";
import { API_PATHS } from "../../../config/ApiPaths";
import { POST_DATA_AIRTIME_BITEL, TYPE_HALOTEL_REVENUE } from "./type";

export const getDataRevenueBitel = (url) => {
  return {
    type: TYPE_BITEL_REVENUE,
    meta: {
      url,
      method: "GET",
    },
  };
};

export const getDataAirtimeBitel = (url) => {
  return {
    type: TYPE_BITEL_AIRTIME,
    meta: {
      url,
      method: "GET",
    },
  };
};

export const postDataRevenueAirtimeBitel = (data) => {
  return {
    type: POST_DATA_AIRTIME_BITEL,
    meta: {
      querry: data,
      url: API_PATHS.postAirtimeBitel,
      method: "POST",
    },
  };
};
